import { render } from "./GoToHomeComponent.vue?vue&type=template&id=52da28e3"
import script from "./GoToHomeComponent.vue?vue&type=script&lang=js"
export * from "./GoToHomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__